
class Liquid {
    constructor(args) {
        this.args = args;
    }

    parseAndRenderSync(str) {
        return str
    }

    registerTag(tag, _function) {
        return
    }

    registerFilter(filter, _function) {
        return
    }
}

module.exports = {
    Liquid
}